import restApiDispatcher from "@/store/utils/api-dispatcher";
import { User } from "@/models";
import { UserDetail } from "../../../services/storage.service";

const setUser = ({ commit }, values) => {
  commit("addUserDetail", values);
  UserDetail.setUserID(values._id);
  UserDetail.setUserRole(values.role);
  UserDetail.setUserQuota(values.freeProfileQuota);
  UserDetail.setUserIsDeleted(values.isDeleted);
  UserDetail.setUserName(values.username);
  UserDetail.setUserEmail(values.email);
};

const getProfile = (context, params) =>
  restApiDispatcher(context, {
    resource: User,
    storeKey: "profile",
    loadingKey: "profileLoading",
    action: "getProfile"
  });

const resetPassword = (context, params) =>
  restApiDispatcher(context, {
    resource: User,
    storeKey: "resetPassword",
    loadingKey: "resetPasswordLoading",
    action: "resetPassword",
    message: "Request Sent, Please Check Your Email",
    params
  });

const changePassword = (context, params) =>
  restApiDispatcher(context, {
    resource: User,
    storeKey: "changePassword",
    loadingKey: "changePasswordLoading",
    action: "changePassword",
    params
  });

const resetTokenPassword = (context, params) =>
  restApiDispatcher(context, {
    resource: User,
    storeKey: "resetPassword",
    loadingKey: "changePasswordLoading",
    action: "resetTokenPassword",
    message: 'Your password has been changed successfully. Please log in.',
    params
  });

const checkToken = (context, params) => 
  restApiDispatcher(context, {
    resource: User,
    storeKey: "token",
    loadingKey: 'changePasswordLoading',
    action: "checkToken",
    silent: true,
    params
  })

export default {
  setUser,
  getProfile,
  resetPassword,
  changePassword,
  resetTokenPassword,
  checkToken
};
